/**
 * Check if the browser supports passive event listeners
 * https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
 */
function checkBrowserPassiveSupport(): boolean {
  try {
    const opts = Object.defineProperty({}, "passive", {
      get: () => true,
    });
    // @ts-expect-error TS(2769): No overload matches this call.
    window.addEventListener("testPassive", null, opts);
    // @ts-expect-error TS(2769): No overload matches this call.
    window.removeEventListener("testPassive", null, opts);
    return true;
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (e) {
    return false;
  }
}

export const isBrowserSupportsPasiveEvents = checkBrowserPassiveSupport();
